import dayjs from 'dayjs';

export enum FEEDBACK_FILTER_VALUE {
  NEGATIVE,
  POSITIVE,
  ALL,
}

export enum CTA_TYPE {
  LEAD_MAGNET = 'lead_magnet',
  ACTION = 'action',
}

export enum MAGNET_TYPE {
  VIDEO = 'video',
  IMAGE = 'image',
  PDF = 'pdf',
}

export enum CTA_ACTION_TYPE {
  CONNECT_TO_AGENT = 'connect_to_agent',
  OPEN_CHATBOT = 'open_chatbot',
  SHOW_CALENDAR = 'show_calendar',
}

export enum URL_CONFIGURATION {
  SPECIFIC_URL = 'specific_url',
  URL_BY_KEYWORD_SEARCH = 'url_by_keyword_search',
}

export const CTA_TYPE_OPTIONS = [
  { label: 'Lead magnet', value: CTA_TYPE.LEAD_MAGNET },
  { label: 'Action', value: CTA_TYPE.ACTION },
];

export const CTA_ACTION_TYPE_OPTIONS = [
  { label: 'Connect to Agent', value: CTA_ACTION_TYPE.CONNECT_TO_AGENT },
  { label: 'Open Chatbot', value: CTA_ACTION_TYPE.OPEN_CHATBOT },
  { label: 'Show Calendar', value: CTA_ACTION_TYPE.SHOW_CALENDAR },
];

const URL_CONFIGURATION_OPTIONS = [
  { label: 'Specific URL', value: URL_CONFIGURATION.SPECIFIC_URL },
  { label: 'URL by Keyword search', value: URL_CONFIGURATION.URL_BY_KEYWORD_SEARCH },
];

export const pageCTADefaultValues = {
  landingPage: '',
  popup_greeting: 'How can we assist you today?',
  popup_headline: '👋 Hi there!',
  // Mirrors of the selected page's saved copy — see IPageCTAForm. Empty until a page
  // is hydrated, which is exactly "this page has no saved popup copy".
  stored_popup_headline: '',
  stored_popup_greeting: '',
  video_link: '',
  url_configuration: URL_CONFIGURATION.SPECIFIC_URL,
  url: '',
  urls: [],
  // An untouched CTA slot is a hidden popup button, so it starts NOT required — it only
  // becomes required to complete once an action is picked for it (PageCTAs'
  // handleValidateOption). Defaulting these to true made "no buttons at all" fail
  // validation on the very first render, before the vendor had touched anything.
  option_a: {
    isRequired: false,
    type: '',
    label: '',
    config: {
      action_type: '',
      magnet_type: '',
      file_id: '',
      url: '',
    },
    date_added: dayjs().format(),
  },
  option_b: {
    isRequired: false,
    type: '',
    label: '',
    config: {
      action_type: '',
    },
    date_added: dayjs().format(),
  },
  option_c: {
    isRequired: false,
    type: '',
    label: '',
    config: {
      action_type: '',
    },
    date_added: dayjs().format(),
  },
};

export enum TRAINING_CONTENT_TYPE {
  TEXT = 'text',
  URL = 'url',
}
